// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bfKn","toggle":"styles_toggle__3GWnb","preview":"styles_preview__3ZgG7"};